/* eslint-disable camelcase */
import * as _braze from '@braze/web-sdk'
import { getUserExternalId } from './braze.util'
import { removeNullishProperty, getEnv } from './common'

class Braze {
  constructor() {
    this.braze = _braze
  }
  initialize() {
    const endpoint =
      getEnv() === 'prd' ? 'sdk.iad-06.braze.com' : 'sdk.iad-07.braze.com'
    this.braze.initialize(process.env.VUE_APP_BRAZE_API_KEY, {
      baseUrl: endpoint,
      enableLogging: true,
    })
  }
  changeUser(externalId) {
    const id = externalId || getUserExternalId()
    if (id !== 'none') {
      this.braze.changeUser(id)
    }
  }
  openSession() {
    this.braze.openSession()
  }
  getUserId() {
    return this.braze.getUser().getUserId()
  }
  connectUser(externalId) {
    if (this.getUserId() !== externalId) {
      this.changeUser(externalId)
    }
    this.openSession()
  }
  purchase(eventProperties) {
    const { product_id, price, currency } = eventProperties
    this.braze.logPurchase(product_id, price, currency, 1, {
      ...eventProperties,
    })
  }

  /**
   * 플레이어로부터 발생한 브레이즈 이벤트의 name와 property를 모두 전달받아 브레이즈로 바로 전송
   * @param {Object} param0
   * @param {string} param0.eventType - 브레이즈 이벤트 타입 (event name)
   * @param {Object} param0.data - 브레이즈 이벤트에 전달할 데이터 (property)
   * @returns
   */
  playerCustomEvent({ eventType, data }) {
    if (!eventType) {
      console.warn('Braze playerCustomEvent: eventType is required')
      return
    }
    const eventProperties = removeNullishProperty(data || {})
    this.braze.logCustomEvent(eventType, {
      ...eventProperties,
    })
  }
}

const braze = new Braze()
export default braze
